<script lang="typescript">
    import { getUsers } from "../api"
    export let activeUser: User
</script>

{#await getUsers()}
    bitte warten ...
{:then users}
    {#each [{ id: 0, firstname: "alle" }, ...users] as user}
        <div>
            <button
                class:active="{activeUser == user}"
                on:click="{() => {
                    activeUser = user
                }}"
            >
                <img src="{user.avatar_url || '/alle.jpg'}" alt="" />
                <span class="hidden-sm">{user.firstname}</span>
            </button>
        </div>
    {/each}
{/await}
